import gsap from "gsap";

const initializedHeaders = new WeakSet<HTMLElement>();

export const initBlogHeaderAnimations = (root: ParentNode = document): void => {
  root.querySelectorAll<HTMLElement>(".bl-header").forEach((section) => {
    if (initializedHeaders.has(section)) return;

    const content = section.querySelector<HTMLElement>(".container.position-relative");
    const items = content
      ? Array.from(content.querySelectorAll<HTMLElement>(".bl-header-animate"))
      : [];
    const fallbackItems = content
      ? Array.from(content.querySelectorAll<HTMLElement>("h1, h2, h3, h4, h5, h6, span, p"))
      : [];
    const animatedItems = items.length ? items : fallbackItems;

    if (!animatedItems.length) return;

    initializedHeaders.add(section);
    gsap.killTweensOf(animatedItems);

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.set(animatedItems, {
        autoAlpha: 1,
        x: 0,
        willChange: "auto",
      });
      return;
    }

    gsap.set(animatedItems, {
      autoAlpha: 0,
      x: -60,
      willChange: "transform,opacity",
    });

    requestAnimationFrame(() => {
      gsap.to(animatedItems, {
        autoAlpha: 1,
        x: 0,
        duration: 0.62,
        stagger: 0.08,
        ease: "power2.out",
        delay: 0.24,
      });
    });
  });
};
